import { ACT_AS_HEADER, ACT_AS_PATHS } from "../../shared/market";

/**
 * Admin › Mercado › "Editar tienda": this tab works as a shop the admin set up (the shop's user id, in
 * sessionStorage so other tabs stay the admin's own). The server checks everything again.
 */
const KEY = "pf_act_as";

export function actingShop(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function startActing(shopId: string): void {
  try {
    sessionStorage.setItem(KEY, shopId);
  } catch {
    // Without storage the panel just stays the admin's own.
  }
}

export function stopActing(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing stored.
  }
}

/**
 * The header for a request while acting: on the shop panel's API, and on every other change so the
 * server refuses it instead of applying it to the admin's own account. Reads elsewhere stay the admin's.
 */
/** Changes that touch no account (identifying a card from its photo): they go as usual. */
const NO_ACCOUNT_WRITES = ["/api/cards/identify"];

export function actAsHeaders(path: string, method = "GET"): Record<string, string> {
  const shop = actingShop();
  if (!shop || !path.startsWith("/api/") || path.startsWith("/api/auth/") || path.startsWith("/api/admin/") || NO_ACCOUNT_WRITES.includes(path)) return {};
  const panel = ACT_AS_PATHS.some((p) => path === p || path.startsWith(p.endsWith("/") ? p : `${p}/`) || path.startsWith(`${p}?`));
  return panel || method.toUpperCase() !== "GET" ? { [ACT_AS_HEADER]: shop } : {};
}
